<template>
  <div :class="$style.pagination">
    <v-row
      v-if="pagination_props.total_items > 0"
      :class="[$style.row, {'flex-column': is_mobile}]"
    >
      <v-pagination
        class="ml-auto mr-auto"
        :class="{'my-4': is_mobile}"
        v-model="page_model"
        color="accent darken-4"
        :total-visible="7"
        :length="pagination_props.total_pages"
      />
      <v-select
        v-if="!hide_page_size"
        :class="$style.pageSelect"
        dense
        hide-details
        :menu-props="{ offsetY: true }"
        :value="select_value"
        :items="[10, 25, 50, 100]"
        @change="page_size"
      >
        <template #prepend>
          <span :class="$style.selectTitle">
            Показывать по:
          </span>
        </template>
      </v-select>
      <div :class="$style.pagesCount">
        {{ pages_title }}
      </div>
    </v-row>
  </div>
</template>

<script lang="ts">
import { PaginationProps } from '@/types';
import { default_pagination_props } from '@/utils';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { global_store } from '@/store';
import Select from '../inputs/select/Select.vue';

@Component({
  components: {
    Select,
  },
})
export default class Pagination extends Vue {
  @Prop({ type: Object, default: () => default_pagination_props() })
  pagination_props!: PaginationProps;

  @Prop({ type: Boolean, default: false })
  hide_page_size!: boolean

  get is_mobile() {
    return global_store.state.isMobile;
  }

  get select_value() {
    return this.pagination_props.limit;
  }

  get page_model() {
    return this.pagination_props.current_page;
  }

  set page_model(page) {
    this.$emit('change_page', page);
  }

  get pages_title() {
    if (!this.pagination_props.total_items) {
      return '';
    }

    const first_number = (this.pagination_props.current_page - 1) * this.pagination_props.limit + 1;
    const second_num_sum = (first_number - 1 + this.pagination_props.limit);
    // если число больше общего количества, то оставляем общее кол-во
    // чтобы не было "41-51 из 43"
    const secont_number = second_num_sum >= this.pagination_props.total_items
      ? this.pagination_props.total_items : second_num_sum;

    return `${first_number}-${secont_number} из ${this.pagination_props.total_items}`;
  }

  page_size(value: number) {
    this.$emit('page_size_changed', value);
  }
}
</script>

<style module lang="scss">
.pagination {
  background-color: $primary_lighten5;

  .row {
    margin: 0;
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
  }

  :global(.v-pagination__item) {
    box-shadow: none;
    font-weight: 400;
    border: 1px solid rgba(0, 0, 0, 0.1);

    &:not(:global(.v-pagination__item--active)) {
      color: rgba(0, 0, 0, 0.87) !important;
    }
  }

  :global(.v-pagination__item--active) {
    pointer-events: none;
  }

  :global(.v-pagination__navigation) {
    box-shadow: none;
    background-color: transparent !important;

    &:hover {
      :global(.v-icon) {
        color: $accent_darken4;
      }
    }
  }
}

.pageSelect {
  max-width: 200px;
  display: flex;
  align-items: center;
  margin-right: 32px;

  :global(.v-input__control) {
    max-width: 60px;
  }

  :global(.v-input__prepend-outer),
  :global(.v-select__selection) {
    font-size: 12px;
    color: $primary_darken1;
  }
}

.selectTitle {
  margin-right: 32px;
}

.pagesCount {
  font-size: 12px;
  color: $primary_darken1;
}

</style>
